import React, { Component } from 'react';
import {
    InputTextTagStyles,
    InputTextTagWrapperStyles,
    SearchTag,
    SearchTags,
    TabPageStyles,
} from './Styled';
import TabPages, { TabStyle } from '../TabBarPages/TabBarPages';
import { TabPage } from '../TabBarPages/Styled';
import InputText from '../FormInputText/FormInputText';
import { MainContentBg, TabContent } from '../../../styles/Styled';
import IconNew from '../IconNew/IconNew';
import { ClearFloats } from '../BaseTemplate/Styled';

class SearchTabBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagInputValue: '',
            tags: [],
        };
    }

    tagChangeHandler = (e) => {
        this.setState({
            tagInputValue: e.target.value,
        });
    };

    tagEnterHandler = () => {
        this.setState((prevState) => {
            let tags = [...prevState.tags];
            tags.push(this.state.tagInputValue);
            return {
                tags,
                tagInputValue: '',
            };
        });
    };

    removeTag = (index) => {
        let tags = [...this.state.tags];
        tags.splice(index, 1);
        this.setState({ tags });
    };

    render() {
        return (
            <MainContentBg>
                <TabContent margin={1}>
                    <TabPages
                        theme={TabStyle.HomePageSearchTab}
                        defaultPageIndex={this.props.defaultIndex}
                        Type='SearchTabBar'
                        
                    >
                        <TabPage title="All" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="add tags..."
                            >
                                <IconNew
                                    bp1="-440"
                                    bp2="-49"
                                    iwidth="26"
                                    iheight="26"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>

                            <ClearFloats />
                        </TabPage>

                        <TabPage title="Listings" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="add tags..."
                            >
                                <IconNew
                                    bp1="-440"
                                    bp2="-49"
                                    iwidth="26"
                                    iheight="26"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>
                            <button onClick={this.props.toggleShow}>
                                {this.props.showMap ? (
                                    <IconNew
                                        bp1="-487"
                                        bp2="-135"
                                        iwidth="19"
                                        iheight="17"
                                    />
                                ) : (
                                    <IconNew
                                        bp1="-488"
                                        bp2="-99"
                                        iwidth="38"
                                        iheight="36"
                                    />
                                )}
                                {'   '}
                                {this.props.showMap ? 'List' : 'Map'}
                            </button>
                            <button>
                                Sort
                                {'   '}
                                <IconNew
                                    bp1="-508"
                                    bp2="-138"
                                    iwidth="24"
                                    iheight="16"
                                />
                            </button>
                            <ClearFloats />
                        </TabPage>

                        <TabPage title="People" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="add tags..."
                            >
                                <IconNew
                                    bp1="-440"
                                    bp2="-49"
                                    iwidth="26"
                                    iheight="26"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>
                            <button onClick={this.props.toggleShow}>
                                {this.props.showMap ? (
                                    <IconNew
                                        bp1="-487"
                                        bp2="-135"
                                        iwidth="19"
                                        iheight="17"
                                    />
                                ) : (
                                    <IconNew
                                        bp1="-488"
                                        bp2="-99"
                                        iwidth="38"
                                        iheight="36"
                                    />
                                )}
                                {'   '}
                                {this.props.showMap ? 'List' : 'Map'}
                            </button>
                            <button>
                                Sort
                                {'   '}
                                <IconNew
                                    bp1="-508"
                                    bp2="-138"
                                    iwidth="24"
                                    iheight="16"
                                />
                            </button>
                            <ClearFloats />
                        </TabPage>
                        <TabPage title="Group" styled={TabPageStyles}>
                            <InputText
                                id="tagsInput"
                                name="tagsInput"
                                type="text"
                                onInput={this.tagChangeHandler}
                                value={this.state.tagInputValue}
                                onEnter={this.tagEnterHandler}
                                styled={InputTextTagStyles}
                                wrapperStyled={InputTextTagWrapperStyles}
                                placeholder="add tags..."
                            >
                                <IconNew
                                    bp1="-440"
                                    bp2="-49"
                                    iwidth="26"
                                    iheight="26"
                                />
                            </InputText>

                            <SearchTags>
                                {this.state.tags.map((tag, index) => (
                                    <SearchTag key={index}>
                                        <IconNew
                                            bp1="-467"
                                            bp2="-60"
                                            iwidth="10"
                                            iheight="15"
                                        />
                                        {tag}
                                        <i
                                            onClick={(e) =>
                                                this.removeTag(index)
                                            }
                                        />
                                    </SearchTag>
                                ))}
                            </SearchTags>
                            <button onClick={this.props.toggleShow}>
                                {this.props.showMap ? (
                                    <IconNew
                                        bp1="-487"
                                        bp2="-135"
                                        iwidth="19"
                                        iheight="17"
                                    />
                                ) : (
                                    <IconNew
                                        bp1="-488"
                                        bp2="-99"
                                        iwidth="38"
                                        iheight="36"
                                    />
                                )}
                                {'   '}
                                {this.props.showMap ? 'List' : 'Map'}
                            </button>
                            <button>
                                Sort
                                {'   '}
                                <IconNew
                                    bp1="-508"
                                    bp2="-138"
                                    iwidth="24"
                                    iheight="16"
                                />
                            </button>
                            <ClearFloats />
                        </TabPage>
                    </TabPages>
                </TabContent>
            </MainContentBg>
        );
    }
}

export default SearchTabBar;
